import { useEffect } from 'react';
import { Modal, TitleBar } from '@shopify/app-bridge-react';

const CorrectScanDialog = ({ shopify, quantity, focusScanArea, switchUnpickable, dialogLineItemId }) => {
  const markUnpickable = () => {
    switchUnpickable(dialogLineItemId);
    shopify.modal.hide('correct-modal');
  }

  const confirm = () => {
    shopify.modal.hide('correct-modal');
    focusScanArea();
  }

  const setFocus = () => {
    let confirm = document.getElementById('modal-close');

    console.log(confirm);
    confirm?.focus();
    
    // console.log('in set focus');
    // let confirm = document.getElementById('correct-confirm');

    // console.log(confirm);
    // confirm?.focus();

    // console.log(document);

    // document.onkeypress = function (e) {
      // e = e || window.event;
      // use e.keyCode
      // console.log(e.keyCode);
    // };

  }

  // useEffect(() => {
  //   console.log('effect');
  //   let confirm = document.getElementById('correct-confirm');
  //   confirm?.focus();
  // }, []);

  return(
    <Modal id="correct-modal" variant="large" onShow={() => setFocus()}>
      <div className="modal-body">
        <p style={{ 'color': '#8e1f0b' }}>
          The scanned item is in this order. Please pick this quantity:
        </p>
        <p>
          { quantity }
        </p>

        <button id="correct-confirm" onClick={() => confirm()}>Test</button>
      </div>
      <TitleBar title="Correct Item">
        <button variant="primary" onClick={() => confirm()}>Confirm</button>
        <button onClick={() => markUnpickable()}>Could not pick</button>
      </TitleBar>
    </Modal>
  )
}

export default CorrectScanDialog;
